import { compose, lifecycle, withState } from 'recompose'

import { sendToSentry } from 'utils/errors'
import removeDuplicateQueryParams from 'utils/sourceAttributes'

export type ZestyOverrideImage = {
  data: {
    type: void
    url: string
    zuid: void
  }
  totalItems: void
  type: void
}

export type ZestyOverride = {
  _canonical_query_param_whitelist: void
  _canonical_tag_custom_value: void
  _canonical_tag_mode: void
  _parent_zuid: void
  _path_full: void
  _path_part: void
  _sitemap_priority: void
  disclosure_override?: string
  hero_image_override_desktop: ZestyOverrideImage
  hero_image_override_mobile: ZestyOverrideImage
  query_param_key: string
  query_param_value?: string
  sort: void
}

export default compose<any, {}>(
  withState('zestyOverride', 'setZestyOverride', null),
  lifecycle<any, {}>({
    componentDidMount() {
      if (!window.location.search) {
        return
      }

      fetch(process.env.PUBLIC_ZESTY_OVERRIDE_URL)
        .then(stream => stream.json())
        .then(json => {
          const zestyOverrides = json && json.data.reverse()
          const zestyOverridesByKey = zestyOverrides.map(el => el.content.query_param_key)

          const queries = removeDuplicateQueryParams(window.location.search)
          for (const query of Object.keys(queries)) {
            if (zestyOverridesByKey.indexOf(query) === -1) {
              continue
            }

            for (let i = 0; i < zestyOverridesByKey.length; i++) {
              if (query === zestyOverridesByKey[i]) {
                const expectedQueryParamValue = zestyOverrides[i].content.query_param_value
                const willOverride =
                  !expectedQueryParamValue || expectedQueryParamValue === queries[query]

                if (willOverride) {
                  this.props.setZestyOverride(zestyOverrides[i].content)
                  break
                }
              }
            }
          }
        })
        .catch(error => {
          sendToSentry(error, {
            name: 'ZestyQueryOverrideError',
            message: 'There was an error fetching or processing Query Overrides from Zesty.',
          })
        })
    },
  }),
)
